import React from 'react';
import { TopBar } from './TopBar';
import { SideNav } from './SideNav';
interface AppShellProps {
  children: React.ReactNode;
}
export const AppShell: React.FC<AppShellProps> = ({
  children
}) => {
  return <div className="min-h-screen bg-surface-secondary flex flex-col font-sans text-text-primary" data-id="element-98">
      <TopBar data-id="element-99" />
      <div className="flex flex-1 overflow-hidden" data-id="element-100">
        <SideNav data-id="element-101" />
        <main className="flex-1 overflow-y-auto p-4 md:p-8" data-id="element-102">{children}</main>
      </div>
    </div>;
};